
import axios from 'axios';
import { combase } from '@/config';

export default {
  async postLinkMenuToUser(body) {
    try {
      const res = await axios.post(`${combase}post/api/v1/linewebservice/LinkMenuToUser`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
